import PropTypes from 'prop-types';
import React from 'react';
import { components } from 'react-select';

export const CustomValueContainer = ({ selectProps, ...props }) => {
  const commonProps = {
    cx: props.cx,
    clearValue: props.clearValue,
    getStyles: props.getStyles,
    getValue: props.getValue,
    getClassNames: props.getClassNames,
    hasValue: props.hasValue,
    isMulti: props.isMulti,
    isRtl: props.isRtl,
    options: props.options,
    selectOption: props.selectOption,
    setValue: props.setValue,
    selectProps,
    theme: props.theme,
    innerProps: props.innerProps
  };

  return (
    <components.ValueContainer {...props} selectProps={selectProps}>
      {props.hasValue ? (
        <components.SingleValue
          {...commonProps}
          data={props.getValue()}
          isDisabled={selectProps.isDisabled}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ marginRight: 4 }}>${selectProps.minPrice}</span>
            <span style={{ marginRight: 4 }}> - </span>
            <span>${selectProps.maxPrice}</span>
          </div>
        </components.SingleValue>
      ) : (
        <components.Placeholder
          {...commonProps}
          key="placeholder"
          isFocused={selectProps.isFocused}
          isDisabled={selectProps.isDisabled}
        >
          {selectProps.placeholder}
        </components.Placeholder>
      )}
    </components.ValueContainer>
  );
};

CustomValueContainer.propTypes = {
  selectProps: PropTypes.shape({
    isDisabled: PropTypes.bool,
    minPrice: PropTypes.number,
    maxPrice: PropTypes.number,
    isFocused: PropTypes.bool,
    placeholder: PropTypes.string
  })
};
